import { Checkbox, Popup } from 'semantic-ui-react';
import { Row } from 'react-table';
import styled from '@emotion/styled';
import { useMonitoringTableContext } from './useMonitoringTableContext';

export interface SelectionCellProps<TData extends { id: number }> {
  row: Row<TData>;
  isSelectable?: (row: TData) => boolean;
  disabledMessage?: string;
}

export const SelectionCell = <TData extends { id: number }>({
  row,
  isSelectable,
  disabledMessage = 'This record cannot be selected',
}: SelectionCellProps<TData>) => {
  const { isSelected, toggleSelection } = useMonitoringTableContext();

  const selectable = isSelectable ? isSelectable(row.original) : true;
  const checked = isSelected(row.original.id);

  return (
    <Popup
      disabled={selectable}
      trigger={
        <S.CheckboxContainer>
          <Checkbox
            checked={checked}
            disabled={!selectable}
            onChange={(_, data) => toggleSelection(row.original.id, data.checked ?? false)}
          />
        </S.CheckboxContainer>
      }
      content={disabledMessage}
      position="top left"
    />
  );
};

const S = {
  CheckboxContainer: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
  `,
};
